import { render, staticRenderFns } from "./medkon_post_list.vue?vue&type=template&id=74efc77a"
import script from "./medkon_post_list.vue?vue&type=script&lang=js"
export * from "./medkon_post_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports